import { render, staticRenderFns } from "./BitacoraDetails.vue?vue&type=template&id=9138c2ea&scoped=true&"
import script from "./BitacoraDetails.vue?vue&type=script&lang=js&"
export * from "./BitacoraDetails.vue?vue&type=script&lang=js&"
import style0 from "./BitacoraDetails.vue?vue&type=style&index=0&id=9138c2ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9138c2ea",
  null
  
)

export default component.exports